import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import OrganizationList from '@app/views/Organization/List';
import { memo } from 'react';

export default memo(
  withIfUser(OrganizationList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
